import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import { reportService } from "../../../apis/apiServices/Report";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { Template } from "devextreme-react";
import { DefaultDateFormat, IconWithTooltip } from "../../../helper/fixcode";
import { useNavigate } from "react-router-dom";

export default function ReportAssetPurchaseComponent() {
  const navigate = useNavigate();
  const [assetPurchaseList, setAssetPurchaseList] = useState([]);
  const refDataGrid = useRef(null);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Asset Purchase`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setTimeout(async () => {
        await getAssetPurchaseList(0, 1);
      }, 0);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getAssetPurchaseList = async (assetPurchaseId, quotationTypeId) => {
    try {
      refDataGrid?.current?.instance?.beginCustomLoading();
      const response = await reportService.getAssetQuotationList(
        assetPurchaseId,
        quotationTypeId
      );
      setAssetPurchaseList(response?.data ?? []);
    } catch (error) {
      console.log(error);
    } finally {
      refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-12">
                <DataGrid
                  ref={refDataGrid}
                  dataSource={assetPurchaseList}
                  showColumnLines={false}
                  showRowLines={true}
                  showBorders={true}
                  allowColumnResizing={false}
                  allowColumnReordering={true}
                  columnAutoWidth={true}
                  onToolbarPreparing={(e) => {
                    e.toolbarOptions.items.unshift({
                      location: "before",
                      template: "toolbarRefreshTemplate",
                    });
                  }}
                >
                  <Column
                    dataField="id"
                    width={25}
                    caption=""
                    allowExporting={false}
                    allowFiltering={false}
                    allowSearch={false}
                    allowSorting={false}
                    cellRender={(cellData) => {
                      const idPrefix = `icon-${cellData?.data?.id}`;
                      return (
                        <>
                          <div style={{ display: "flex" }}>
                            <span>
                              <IconWithTooltip
                                id={`${idPrefix}-view`}
                                className="iconify-size mr-1"
                                title="View"
                                tooltip="View"
                                icon="solar:document-text-outline"
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  navigate("/asset-purchase-preview", {
                                    state: {
                                      requestQuotationId: cellData?.data?.id,
                                      quotationIndentNo:
                                        cellData?.data?.quotationNo,
                                      quotationTypeId:
                                        cellData?.data?.quotationTypeId,
                                      sourceUrl: "ReportAssetPurchase",
                                      isReport: true,
                                    },
                                  })
                                }
                              />
                            </span>
                          </div>
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="assetRequestNo"
                    caption="Asset Request No"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="quotationNo"
                    caption="Asset Quotation No"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="quotataionDate"
                    caption="Quotataion Date"
                    allowFiltering={false}
                    allowSearch={true}
                    dataType="date"
                    format="dd-MMM-yyyy"
                  />
                  <Column
                    dataField="fromProjectName"
                    caption="Project"
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.fromProjectName || ""} ${
                        data?.toProjectName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.fromProjectName ?? ""}</span>
                          {data?.data?.toProjectName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.toProjectName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="fromLocation"
                    caption="Transfer From/To"
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.fromLocation || ""} ${
                        data?.toLocation || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.fromLocation ?? ""}</span>
                          {data?.data?.toLocation && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.toLocation ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="fromUserFullName"
                    caption="From"
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.fromUserFullName || ""} ${
                        data?.fromDepartmentName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.fromUserFullName ?? ""}</span>
                          {data?.data?.fromDepartmentName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.fromDepartmentName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="toUserFullName"
                    caption="To"
                    allowSearch={true}
                    calculateCellValue={(data) => {
                      return `${data?.toUserFullName || ""} ${
                        data?.toDepartmentName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      return (
                        <>
                          <span>{data?.data?.toUserFullName ?? ""}</span>
                          {data?.data?.toDepartmentName && (
                            <>
                              <br />
                              <div
                                style={{ color: "#b1b1b1", fontSize: "11px" }}
                              >
                                {data?.data?.toDepartmentName ?? ""}
                              </div>
                            </>
                          )}
                        </>
                      );
                    }}
                  />
                  <Column
                    dataField="transferType"
                    caption="Quotation Type"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="quotationStatus"
                    caption="Status"
                    allowFiltering={false}
                    allowSearch={true}
                  />
                  <Column
                    dataField="approvedDate"
                    caption="Approved By"
                    allowSearch={true}
                    allowFiltering={false}
                    calculateCellValue={(data) => {
                      return `${data?.approvedDate || ""} ${
                        data?.approvedByUserFullName || ""
                      }`;
                    }}
                    cellRender={(data) => {
                      if (data?.data?.approvedDate) {
                        return (
                          <>
                            <span>
                              {moment(data?.data?.approvedDate).format(
                                "DD/MM/YYYY"
                              ) +
                                " " +
                                moment(data?.data?.approvedDate).format("LT") ??
                                ""}
                            </span>
                            <br />
                            <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                              {data?.data?.approvedByUserFullName ?? ""}
                            </div>
                          </>
                        );
                      } else {
                        return "";
                      }
                    }}
                  />
                  <Template
                    name="toolbarRefreshTemplate"
                    render={() => {
                      return (
                        <>
                          <button
                            className="btn btn-outline-primary btn-sm"
                            onClick={async () => {
                              await getAssetPurchaseList(0, 1);
                            }}
                            title="Refresh"
                          >
                            <FontAwesomeIcon icon={faRefresh} />
                            &nbsp;Refresh
                          </button>
                        </>
                      );
                    }}
                  />
                  <HeaderFilter visible={false} />
                  <SearchPanel
                    visible={true}
                    highlightCaseSensitive={true}
                    width={240}
                    placeholder="Search..."
                  />
                  <Paging defaultPageSize={15} />
                  <Pager displayMode="compact" showInfo={true} visible={true} />
                  <Export enabled={true} fileName="Asset Purchase Report" />
                </DataGrid>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
